import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { computed, ref, watch } from "vue";
import { useHierarchyTags } from "shared/composables/hierarchyTags";
import { usePlanConfig } from "shared/composables/planner";
import { useShortenedProcessesWithTags } from "shared/composables/process";
import { useProjectDurationSettings } from "shared/composables/projectDurationSettings";
import { useTrackEvent } from "shared/composables/tracking";
import projectProgressService from "@/services/projectProgressService";
import ProjectProgressModal from "@/views/reports/plots/query_value/ProjectProgressModal.vue";

const precision = 1;


export default /*#__PURE__*/_defineComponent({
  __name: 'PlannerProgressBadge',
  props: {
    origin: {}
  },
  setup(__props: any) {



const isProjectProgressModalOpen = ref(false);

const trackEvent = useTrackEvent();
const { planConfig } = usePlanConfig();
const { shortenedProcessesWithTags } = useShortenedProcessesWithTags();
const { projectDurationSettings } = useProjectDurationSettings();
const { hierarchyTags } = useHierarchyTags();

const progress = computed(() => {
  if (
    !planConfig.value ||
    !shortenedProcessesWithTags.value ||
    !projectDurationSettings.value ||
    hierarchyTags.value.length === 0
  ) {
    return null;
  }
  return projectProgressService.calculateProjectProgressPercentage(
    planConfig.value,
    shortenedProcessesWithTags.value,
    projectDurationSettings.value,
    hierarchyTags.value,
  );
});

const formatNumber = (value: number | null) => {
  if (value === null || !Number.isFinite(value)) {
    return "";
  }
  return value.toLocaleString(window.navigator.language, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
};

const formattedProgress = computed(() => {
  if (progress.value === null) {
    return null;
  }
  return formatNumber(progress.value * 100);
});

watch(progress, (newValue) => {
  // If progress > 10%, show jimo tip
  if (newValue && newValue > 0.1) {
    window.jimo?.push([
      "do",
      "boosted:trigger",
      [{ evolutionId: "469aa1d8-3b81-4be0-b1df-cd3901f51101" }],
    ]);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (progress.value !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "planner-progress-badge",
          class: "font-bold text-sm hover:underline flex items-center gap-1 cursor-pointer rounded-full bg-gray-300 text-gray-700 px-3 py-1 self-center h-min",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
      isProjectProgressModalOpen.value = true;
      _unref(trackEvent)('progress_detail_click', { origin: _ctx.origin });
    })
        }, [
          _createTextVNode(_toDisplayString(formattedProgress.value) + " % ", 1),
          _createVNode(_unref(MagnifyingGlassIcon), { class: "w-4 h-4" })
        ]))
      : _createCommentVNode("", true),
    (isProjectProgressModalOpen.value && _unref(planConfig) && _unref(shortenedProcessesWithTags))
      ? (_openBlock(), _createBlock(ProjectProgressModal, {
          key: 1,
          planConfig: _unref(planConfig),
          processes: _unref(shortenedProcessesWithTags),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isProjectProgressModalOpen.value = false))
        }, null, 8, ["planConfig", "processes"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})